export const API_ENDPOINTS = {
    EXPENSE: "expense",
    EXPENSECATEGORY: "expense_category",
    INVENTORYCATEGORY: "inventory_category",
    INVENTORY: "inventory",
    REPORT: "report",
    ORDER_TYPE: "order_types",
    PAYMENT_TYPE: "payment_type",
    COUPONS: "coupons",
}